import { render, staticRenderFns } from "./MoreBenefits.vue?vue&type=template&id=2a7a0d3a"
import script from "./MoreBenefits.vue?vue&type=script&lang=js"
export * from "./MoreBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports